import { Component, OnInit } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { catchError, tap } from "rxjs/operators";
import { Observable, of } from "rxjs";
import { SeoService } from "src/app/services/seo.service";

const httpOptions = {
  headers: new HttpHeaders({
    "Content-Type": "application/json",
    Accept: "application/json",
    // "Access-Control-Allow-Origin":
    //   "https://video2manual.de, https://www.video2manual.de",
  }),
};

@Component({
  selector: "v2m-download",
  templateUrl: "./download.component.html",
  styleUrls: ["./download.component.scss"],
})
export class DownloadComponent implements OnInit {
  downloadApiUrl = "https://api.video2manual.de/downloads/requestdownload";
  newsletterApiUrl = "https://api.video2manual.de/newsletters/register";
  salutation = "";
  lastname = "";
  firstname = "";
  email = "";
  phone = "";
  company = "";
  privacy = false;
  newsletter = false;
  isCreating = false;
  isCreated = false;

  constructor(private http: HttpClient, private seo: SeoService) {}

  ngOnInit() {
    this.seo.updateTitle("video2manual - Download");
    this.seo.updateKeywords("Download,Testversion");
  }

  send() {
    const request = {
      FileName: "v2msetup.msi",
      Email: this.email,
      Salutation: this.salutation,
      FirstName: this.firstname,
      LastName: this.lastname,
      Phone: this.phone,
      CompanyName: this.company,
    };

    this.isCreating = true;

    this.http
      .post(this.downloadApiUrl, request, httpOptions)
      .pipe(catchError(this.handleError<any>("requestdownlaod")))
      .subscribe((_) => {
        this.isCreating = false;
        this.isCreated = true;
      });

    if (this.newsletter) {
      this.requestNewsletter();
    }
  }

  private requestNewsletter() {
    const request = {
      Email: this.email,
      Salutation: this.salutation,
      FirstName: this.firstname,
      LastName: this.lastname,
      Phone: this.phone,
      CompanyName: this.company,
      RegistrationMethod: "Website",
    };

    this.http
      .post(this.newsletterApiUrl, request, httpOptions)
      .subscribe((_) => {
        console.log("Newsletter request was sended");
      });
  }

  private handleError<T>(operation = "operation", result?: T) {
    return (error: any): Observable<T> => {
      console.error(error);

      return of(result as T);
    };
  }
}
